module.exports = __webpack_public_path__ + "static/media/hearclearpro-earwax-guard-3.c2b529b1.png";